import { AbjadArabicIcon } from './AbjadArabicIcon';

/**
 * author: Haley Halcyon
 * id E20665F3-5354-46C2-9162-4202B20DCA05
 * name abjad-arabic
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/abjad-arabic.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemArabicIcon = AbjadArabicIcon;
export default WritingSystemArabicIcon